<!-- This component is currently used for testing purpose only -->
@if (currentUser) {
<div id="user2s" class="div-right-panel-component">
  <form [formGroup]="changePwdForm">
    <mat-form-field>
      <input
        matInput
        type="password"
        name="credential"
        placeholder="Password:"
        formControlName="credential"
        matTooltip="Password must have a minimum of 8 characters, 1 special character[ _!@#$%^&*() ], 1 upper case, 1 lower case and 1 number" />
    </mat-form-field>
    @if (f.credential.touched && (f.credential.errors?.required || f.credential.errors?.pattern)) {
    <mat-error> Password must have a minimum of 8 characters, 1 special character[ _!&#64;#$%^&*() ], 1 upper case, 1 lower case and 1 number </mat-error>
    }
    <mat-form-field>
      <input matInput type="password" name="confirmCredential" placeholder="Confirm Password:" formControlName="confirmCredential" />
    </mat-form-field>
    @if (f.confirmCredential.touched && (f.confirmCredential.errors?.required || f.confirmCredential.hasError('passwordmatch'))) {
    <mat-error> Passwords don't match </mat-error>
    }
    <br />
    <div class="save-button-div">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="!changePwdForm.valid || !changePwdForm.dirty">Update Password</button>
    </div>
  </form>
</div>
}
